<script>
    import PageBox from "../layouts/PageBox.svelte";
    import ContentBox from "../layouts/ContentBox.svelte";
</script>

<PageBox pageTitle="Deine Ergebnisse">       
    <ContentBox>
        <div class="text-center">
            <p class="text-4xl">🏁</p>
            <p>Dein Fragebogen wird ausgewertet. Wir melden uns bei dir, sobald wir mit der Auswertung fertig sind!</p>
        </div>
    </ContentBox>
</PageBox>